enum EColors {
  Black = '#000000',
  White = '#ffffff',
}

export default EColors;
